import React from 'react'
import SideBar from '../SideBar'
import TableCategoriesAdmin from '../../../Compnents/TableCategoriesAdmin'

function Categories() {
  return (
<SideBar>
  <TableCategoriesAdmin/>
</SideBar>
  )
}

export default Categories
